<template>
  <div class="become-a-professional-modal">
    <div class="become-a-pro-form">
      <div
        data-w-id="aab9549a-fd5e-9f40-2579-14980e2e5a80"
        class="link-block-5 w-inline-block"
        @click="cancel"
      >
        <img src="@/assets/timeslot-images/cancel.svg" loading="lazy" alt="" />
      </div>
      <div class="div-block-52">
        <h1 class="modal-heading">Become a professional</h1>
      </div>
      <div class="div-block-55">
        <div class="text-block-48">Category</div>
        <FormulateInput
          type="select"
          validation="required"
          name="professionalCategory"
          validation-name="Category"
          placeholder="e.g Technology"
          :options="categories"
          input-class="select-field"
          v-model="professionalCategory"
        />
      </div>
      <div class="div-block-55">
        <div class="text-block-48">Role</div>
        <FormulateInput
          type="select"
          validation="required"
          name="professionalSubCategory"
          validation-name="Role"
          placeholder="e.g Software Engineer"
          :options="categoryObject[professionalCategory]"
          input-class="select-field"
          v-model="createModel.professionalSubCategory"
        />
      </div>
      <!--      <div class="div-block-55">-->
      <!--        <div class="text-block-48">Level of Experience</div>-->
      <!--        <FormulateInput-->
      <!--          type="select"-->
      <!--          validation="required"-->
      <!--          validation-name="Level of Experience"-->
      <!--          name="professionalExperienceLevel"-->
      <!--          placeholder="e.g Beginner"-->
      <!--          :options="levels"-->
      <!--          input-class="select-field"-->
      <!--          v-model="createModel.professionalExperienceLevel"-->
      <!--        />-->
      <!--      </div>-->
      <!--      <div class="div-block-55">-->
      <!--        <div class="text-block-48">Years of Experience</div>-->
      <!--        <FormulateInput-->
      <!--          type="number"-->
      <!--          validation="required"-->
      <!--          validation-name="Years of Experience"-->
      <!--          name="professionalExperienceLength"-->
      <!--          placeholder="Enter years of experience"-->
      <!--          input-class="select-field"-->
      <!--          v-model="createModel.professionalExperienceLength"-->
      <!--        />-->
      <!--      </div>-->
      <div class="div-block-55">
        <div class="text-block-48">Professional Summary</div>
        <FormulateInput
          type="textarea"
          validation="required"
          validation-name="Professional summary"
          name="professionalSummary"
          placeholder="Write a summary of your professional work experience"
          input-class="select-field"
          v-model="createModel.professionalSummary"
        />
      </div>
      <!--      <div class="div-block-55">-->
      <!--        <div class="text-block-48">Booking Fee</div>-->
      <!--        <FormulateInput-->
      <!--          type="number"-->
      <!--          validation="required"-->
      <!--          validation-name="Booking fee"-->
      <!--          name="professionalBookingFee"-->
      <!--          placeholder="0.00"-->
      <!--          input-class="select-field"-->
      <!--          help="Booking fee is in dollars"-->
      <!--          v-model="createModel.professionalBookingFee"-->
      <!--        />-->
      <!--      </div>-->
      <div class="div-block-55">
        <div class="sub-container">
          <div class="sub-text">Do you want a subscription plan?</div>
          <div class="sub-switch">
            <label class="switch">
              <input type="checkbox" v-model="ifChecked" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div>

      <div class="sub-container" v-if="ifChecked">
        <div style="width: 48%;">
          <FormulateInput
            placeholder="Frequency"
            type="select"
            :options="['Weekly', 'Monthly']"
            v-model="plan1"
          />
        </div>
        <div style="width: 48%;">
          <FormulateInput
            placeholder="Enter price"
            type="number"
            v-model="amount1"
          />
        </div>
      </div>
      <div class="add-more" @click="toggleMore" v-if="!more && ifChecked">
        + Add more plan
      </div>
      <div class="sub-container" v-if="more && ifChecked">
        <div style="width: 48%;">
          <FormulateInput
            placeholder="Frequency"
            type="select"
            :options="['Weekly', 'Monthly']"
            v-model="plan2"
          />
        </div>
        <div style="width: 48%;">
          <FormulateInput
            placeholder="Enter price"
            type="number"
            v-model="amount2"
          />
        </div>
      </div>
      <div class="add-more" @click="toggleMore" v-if="more && ifChecked">
        - Remove plan
      </div>
      <BaseComponentLoader
        v-if="loader.nonBlockingLoader"
        loaderAlignment="center"
      />
      <div
        data-w-id="ed1ec533-8705-8090-013e-7c7654bbd163"
        class="button-12 w-button"
        @click="createProfessional"
        v-else
      >
        Proceed
      </div>
      <div class="cancel w-button" @click="cancel">Cancel</div>
    </div>
  </div>
</template>

<script>
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import ProfessionalRequest from "@/model/requests/ProfessionalRequest";
import { mapState } from "vuex";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";

export default {
  name: "BecomeAProfessionalModal",
  components: { BaseComponentLoader },
  props: {
    cancel: Function,
    categories: Array,
    categoryObject: Object,
    levels: Array
  },
  data() {
    return {
      createModel: ProfessionalRequest.create,
      professionalCategory: "Aviation",
      more: false,
      ifChecked: false,
      plan1: null,
      amount1: null,
      plan2: null,
      amount2: null
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo
    }),
    ...mapState(["loader"])
  },
  watch: {
    plan1(newValue) {
      if (newValue === "Weekly" && this.plan2 === null) {
        this.createModel.weeklySubscriptionAmount = this.amount1;
      } else if (newValue === "Monthly" && this.plan2 === null) {
        this.createModel.monthlySubscriptionAmount = this.amount1;
      } else if (newValue === "Weekly" && this.plan2 === "Monthly") {
        this.createModel.weeklySubscriptionAmount = this.amount1;
        this.createModel.monthlySubscriptionAmount = this.amount2;
      } else if (newValue === "Monthly" && this.plan2 === "Weekly") {
        this.createModel.monthlySubscriptionAmount = this.amount1;
        this.createModel.weeklySubscriptionAmount = this.amount2;
        // } else if (newValue === null) {
        //   this.createModel.monthlySubscriptionAmount = null;
        //   this.createModel.weeklySubscriptionAmount = null;
      }
    },
    more(newValue) {
      if (newValue === false) {
        this.plan2 = null;
        this.amount2 = null;
      }
    }
  },
  methods: {
    createProfessional() {
      this.createModel.professionalCategory = this.professionalCategory;
      this.createModel.professionalCustomerId = this.userInfo.customerId;
      if (this.plan1 === "Weekly" && this.plan2 === "Monthly") {
        this.createModel.weeklySubscriptionAmount = this.amount1;
        this.createModel.monthlySubscriptionAmount = this.amount2;
      } else if (this.plan1 === "Monthly" && this.plan2 === "Weekly") {
        this.createModel.weeklySubscriptionAmount = this.amount2;
        this.createModel.monthlySubscriptionAmount = this.amount1;
      } else {
        this.createModel.weeklySubscriptionAmount = null;
        this.createModel.monthlySubscriptionAmount = null;
      }
      StoreUtils.dispatch(
        StoreUtils.actions.professional.CREATE_PROFESSIONAL,
        this.createModel
      );
    },
    toggleMore() {
      this.more = !this.more;
    }
  },

  mounted() {}
};
</script>

<style scoped>
.add-more {
  color: #256ff6;
  text-decoration: none;
  cursor: pointer;
  font-size: 14px;
}

.sub-container {
  display: flex;
  justify-content: space-between;
}

.sub-text {
}
.sub-switch {
}

.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #256ff6;
}

input:focus + .slider {
  box-shadow: 0 0 1px #256ff6;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 24px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
